
import React, { Fragment, useState } from 'react'
import {AppButton,AppRow,AppGridBar,AppForm,AppGridTabs, AppTable,AppAction} from 'qcc'
import { Row, Icon ,Col} from 'antd';
import api, {Custom,OrderInputT} from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'

let inputConfig = {
    example : {tel1: '',
        type: '1',
        zjnum: '',
        zprojectno: '',
    } as OrderInputT,
    formdata:{type:'1'},
    labelWidth:100 ,
    items:
    [
        {lable:'项目',field:'zprojectno',placeholder:'string类型:SAP项目P码'},
        {lable:'证件号码',field:'zjnum',placeholder:'string类型:证件号码'},
        {lable:'电话号码',field:'tel1',placeholder:'string类型:电话号码'},
        {lable:'参数对象',field:'type',itemType:'label' }
    ]
};

let outputExample = [
    {
        cust_NAME:'客户名称',
	custnum:'客户编码',
	tel1:'联系号码',
	zj_NUM:'证件号码',
	zj_TYPE:'证件类型',
    }
 ] as Custom[]

export const SapGetCustomerList = () =>{

    const[outputResult,setOutputResult]  = useState([] as Custom[])
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let inputParam = refPosApiInputContent.current.getFormData();
        AppAction.coverFull();
        let res = await api.public.possap.getCustomList(inputParam);
        setOutputResult(res);
        AppAction.cancelCoverFull();
    }

    const renderOutput = () =>{
        console.log('outputResult:',outputResult)
        if(outputResult===null) return '';

        switch(outputView){
            case 0:
            return <RoomTable list={outputResult}/>;
        }

        return  <pre>{JSON.stringify(outputResult, null, 4)}</pre>;
    }
    
    let refPosApiInputContent = React.createRef<PosApiInputContent>();
    return (<div className='app-demo-content'>
            <h1>SAP获取获取收款单/认筹单/签约(客户信息)</h1>    
            <div>
                1、调用SAP接口获取SAP客户信息<br/>
                2、应用场景为POSAPP暂收款前确定客户ID <br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent ref={refPosApiInputContent} config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['列表','JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={16} className='app-pos-api-input-form'>
                        {renderOutput()}
                    </Col>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>
    </div>)
}


const RoomTable = (props:{list:any[]}) =>{
    return ( <AppTable  dataSource={props.list}>
        <AppTable.ColIndex />
        <AppTable.Col field='cust_NAME' title='客户名称'  width={100}/>
        <AppTable.Col field='custnum' title='客户编码' width={100}/>
        <AppTable.Col field='tel1' title='联系号码' width={100}/>
        <AppTable.Col field='zj_NUM' title='证件号码' width={100}/>
        <AppTable.Col field='zj_TYPE' title='证件类型'  width={100}/>
     </AppTable>)
}



// WEBPACK FOOTER //
// ./src/posapi/sap/SapGetCustomerList.tsx